import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Project, ProjectCreate } from "../../../../Constants/Constants";
import CreateNewProjectForm from "./CreateNewProjectForm"

const CreateNewContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ProjectCreate} parent={Project} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <CreateNewProjectForm />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreateNewContainer;
